import * as React from "react";
function SvgYoutube(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="red"
        d="M31.33 8.15a4.05 4.05 0 00-2.83-2.89C26 4.58 16 4.58 16 4.58s-10 0-12.5.68A4.05 4.05 0 00.67 8.15 43 43 0 000 16a43 43 0 00.67 7.85 4.05 4.05 0 002.83 2.89c2.49.68 12.5.68 12.5.68s10 0 12.5-.68a4.05 4.05 0 002.83-2.89A43 43 0 0032 16a43 43 0 00-.67-7.85"
      />
      <path fill="#fff" d="M12.75 21.08L21 16.21l-8.27-4.87z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgYoutube);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
